export const PROJECT = 'project';
export const OUTPUT = 'output';

export const isProject = (content) => content?.content_type === PROJECT;
export const isOutput = (content) => content?.content_type === OUTPUT;
